import styles from "./Testimonials.module.scss";
import { useEffect, useState } from "react";
import { fetchTestimonialsAdmin } from "../../../../api/testimonial";
import TestimonialTable from "./TestimonialTable/TestimonialTable";
import SelectCustom from "../../../../components/SelectCustom/SelectCustom";
import { usePageTitle } from "../../../../contexts/PageTitleContext";
import Modal from "../../../../components/Modal/Modal";

function Testimonials() {
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle("Témoignages clients");
  });

  const [testimonials, setTestimonials] = useState([]);
  const [filter, setFilter] = useState("all");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getTestimonials = async () => {
      setLoading(true);
      try {
        const response = await fetchTestimonialsAdmin();
        if (response.status === 200) {
          setTestimonials(response.data);
          setError(null);
        } else {
          setError(
            "Une erreur s'est produite lors de la récupération des témoignages",
          );
        }
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des témoignages : ",
          error,
        );
        setError(
          "Une erreur s'est produite lors de la récupération des témoignages",
        );
      } finally {
        setLoading(false);
      }
    };

    getTestimonials();
  }, []);

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const filteredTestimonials = testimonials.filter((testimonial) => {
    if (filter === "all") {
      return true;
    } else if (filter === "pending") {
      return !testimonial.isProcessed;
    } else {
      return testimonial.isProcessed;
    }
  });

  return (
    <div className={`${styles.container} ${!loading ? styles.loaded : ""}`}>
      {loading ? null : testimonials.length > 0 ? (
        <div>
          <h2 className={styles.title}>Listes des témoignages client</h2>
          <div className="d-flex justify-content-center m-20">
            <SelectCustom
              label="Filtrer par statut :"
              options={[
                { id: "all", label: "Tous les témoignages" },
                { id: "pending", label: "Témoignages en attente" },
                { id: "processed", label: "Témoignages validés / refusés" },
              ]}
              valueProp="id"
              labelProp="label"
              initialValue="all"
              minWidth={300}
              onChange={handleFilterChange}
            />
          </div>

          <TestimonialTable
            testimonials={filteredTestimonials}
            setTestimonials={setTestimonials}
          />
        </div>
      ) : (
        <div>
          <p>Aucun témoignages</p>
        </div>
      )}

      <div className="modalErrorContainer">
        <Modal
          isOpen={error !== null}
          onClose={() => setError(null)}
          errorMessage={error}
        >
          <h2 className="titleModal">ERREUR</h2>
        </Modal>
      </div>
    </div>
  );
}

export default Testimonials;
